import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import ImageCarousel from '../components/ImageCarousel';
import { useLanguage } from '../context/LanguageContext';
import usePageMeta from '../hooks/usePageMeta';

const CONTENT = {
  lodges: {
    images: [
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/915nlffs_Barefoot3361.jpg'
    ],
    metaTitle: 'Our Rooms — Luxury Stay in São Vicente, Cabo Verde | Hotel Respiro',
    metaDescription: 'A luxury stay in São Vicente: 20 ocean-view rooms at Hotel Respiro, a beach hotel in Baía João Évora, Cabo Verde. Opening Spring 2027.',
    tagline: 'A luxury stay in São Vicente — the beach hotel experience of Cabo Verde.'
  },
  villas: {
    images: [
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/pi8lw8g4_Barefoot3140.jpg',
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/ch2gywec_Barefoot1581.jpg',
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/sr8o531l_Barefoot0091.jpg',
      'https://customer-assets.emergentagent.com/job_respiro-retreat/artifacts/3qlkf8wa_Barefoot1416.jpg'
    ],
    metaTitle: 'Our Villas — Villas for Rent in São Vicente, Cabo Verde | Hotel Respiro',
    metaDescription: 'Villas for rent in São Vicente, Cabo Verde: four private villas with pools at Hotel Respiro, Baía João Évora. A luxury hotel refuge facing the Atlantic.',
    tagline: 'Villas for rent in São Vicente, Cabo Verde — four private villas facing the Atlantic.'
  }
};

export default function StayDetailPage({ type }) {
  const { t } = useLanguage();
  const { images, metaTitle, metaDescription, tagline } = CONTENT[type];
  usePageMeta(metaTitle, metaDescription);

  const features = t(`stay.${type}.features`);

  return (
    <PageLayout>
      <section className="py-10 md:py-16 bg-neutral-50" data-testid={`${type}-page`}>
        <div className="container mx-auto px-6 md:px-12 max-w-[1400px]">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-black mb-4">
              {t(`stay.${type}.title`)}
            </h1>
            <p className="text-black/60 uppercase tracking-[0.15em] text-xs">
              {t(`stay.${type}.details`)}
            </p>
            <p className="text-black/50 text-sm font-light italic mt-3" data-testid={`${type}-seo-tagline`}>
              {tagline}
            </p>
          </div>

          {/* Image Carousel */}
          <div className="max-w-4xl mx-auto mb-12">
            <ImageCarousel images={images} alt={t(`stay.${type}.title`)} className="aspect-[4/3]" />
          </div>

          {/* Description + Features */}
          <div className="max-w-3xl mx-auto">
            <p className="text-base md:text-lg text-black/80 leading-relaxed mb-8 font-light">
              {t(`stay.${type}.description`)}
            </p>
            <ul className="space-y-3 mb-12">
              {features && features.map((feature) => (
                <li key={feature} className="flex items-center gap-3 text-black/70">
                  <span className="text-black/50 text-xs flex-shrink-0">•</span>
                  <span className="text-sm">{feature}</span>
                </li>
              ))}
            </ul>
            <div className="text-center">
              <Link
                to="/contact"
                className="inline-block px-8 py-4 bg-[#D4C5B0] text-black uppercase tracking-[0.15em] text-xs font-medium hover:bg-[#c4b5a0] transition-colors duration-300"
                data-testid={`${type}-page-cta`}
              >
                {t(`stay.${type}.cta`)}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
